import { MeasureIntervalStateBase } from '../../types/measureIntervalState.js';

type MeasureIntervalState = MeasureIntervalStateBase<any>;


export function getMeasurementsIssues(table: MeasureIntervalState[]): number {
    let numIssues = 0;
    for (const row of table) {
        const isHelpMe = row.stopStatus === 'helpMe';
        if (isHelpMe || row.isIntervalUp) {
            numIssues++;
        }
    }
    return numIssues;
}
